import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';
import {
  BindingTarget,
  IBindingConnectionItem,
  IDataBindingItem,
} from './types';

export class CmsBindingConnectionItem implements IBindingConnectionItem {
  #privateAPI: any;
  constructor(
    privateAPI: any,
    private pointer: any,
    private bindingTarget: BindingTarget,
    public config: Record<string, any>,
  ) {
    this.#privateAPI = privateAPI;
  }

  public async update(data: Partial<IDataBindingItem>) {
    const updated = await this.#privateAPI.bindings.update(
      this.pointer,
      this.bindingTarget,
      {
        config: data.config ?? this.config,
        role: data.role,
      },
    );
    this.config = updated;
  }

  public async delete() {
    await this.#privateAPI.bindings.delete(this.pointer, this.bindingTarget);
    this.config = {};
  }
}

export class CmsBindingsSDKShape extends BaseSDKShape {
  public async get(
    target: BindingTarget,
  ): Promise<IBindingConnectionItem | null> {
    const privateAPI = await this.getPlatformPrivateAPI();
    const editorPointer =
      await privateAPI.components.getSingleSelectedEditorPointer();

    if (!editorPointer) {
      return null;
    }

    const config = privateAPI.bindings.get(editorPointer, target);

    if (!config) {
      return null;
    }

    return new CmsBindingConnectionItem(
      privateAPI,
      editorPointer,
      target,
      config,
    );
  }
}

export default new PlatformSDKShape(CmsBindingsSDKShape)
  .withPublicMethod('get')
  .build();
